import React, { useEffect, useMemo, useState } from "react";
import { useForm } from "react-hook-form";

import { AdminLayout } from "../../layouts"
import { Box, Button, Chip, CircularProgress, Container, Dialog, DialogActions, DialogContent, DialogContentText, DialogTitle, Divider, FormControlLabel, Grid, IconButton, Menu, MenuItem, Modal, Paper, Switch, TextField, Typography } from "@mui/material"
import { Delete, Edit, MoreVert } from "@mui/icons-material";


import {
  DataGrid, GridToolbar, GridRowsProp, GridColDef, GridFilterModel,
  GridColumnVisibilityModel,
  GridCellParams
} from '@mui/x-data-grid';
import { deleteSedeCorreosCR, getSedesCorreosCRAdmin, postSedeCorreosCR, putSedeCorreosCR } from "../../api/providers";
import { LoadingScreen } from "../../ui/components/LoadingScreen";


import Cookies from "js-cookie";






export const SedeCorreosCR = () => {

  const token: any = Cookies.get("token");

  const RowMenu = (params: any) => {
    let paramsRow = params.rowIndex;

    const [anchorEl, setAnchorEl] = React.useState(null);
    const open = Boolean(anchorEl);

    const handleClick = (event: any) => {
      setAnchorEl(event.currentTarget);
    };

    const handleClose = () => {
      setAnchorEl(null);
    };

    return (
      <>
        <IconButton
          aria-label="more"
          id={`long-button-${paramsRow.id}`}
          aria-controls={open ? 'long-menu' : undefined}
          aria-expanded={open ? 'true' : undefined}
          aria-haspopup="true"
          onClick={handleClick}
        >
          <MoreVert />
        </IconButton>
        <Menu
          id={`long-menu-${paramsRow.id}`}
          MenuListProps={{
            'aria-labelledby': `long-button-${paramsRow.id}`,
          }}
          anchorEl={anchorEl}
          open={open}
          onClose={handleClose}
        >

          <MenuItem onClick={() => handleOpenEditDialog(paramsRow)}>Editar Sede</MenuItem>
          <MenuItem onClick={() => handleOpenDeleteDialog(paramsRow)}>Eliminar Sede</MenuItem>


        </Menu>
      </>
    );
  };


  /* las tablas start */
  const columns: GridColDef[] = useMemo(() => [

    // ACCIONES
    {
      field: 'acciones', headerName: '', width: 50,
      renderCell: (params) => <RowMenu rowIndex={params.row} />,
    },

    { field: 'nombre', headerName: 'Nombre', width: 250 },
    { field: 'direccion', headerName: 'Direccion', width: 250 },
    { field: 'provincia', headerName: 'Provincia', width: 150 },
    //verificar si requiere requiereRetiroEnCorreos que es un boolean en la db
    {
      field: 'inscripciones', headerName: 'Solicitudes de Envíos', headerAlign: "left", width: 150, type: 'string',

      renderCell: (params: GridCellParams) => (
        <Chip
          label={params.value as string}
          sx={{
            backgroundColor: "secondary.dark",
            color: "white", // Texto en blanco para mejor visibilidad
            borderRadius: 1, // Bordes redondeados
            width: "100%", // Ancho fijo
            fontWeight: "bold", // Fuente en negrita
            fontSize: "1rem", // Tamaño de fuente más pequeño
          }} />),
    },
  ], []);

  const [sedes, setSedes] = useState<any>([]);
  const [loading, setLoading] = useState<any>(true);
  const [error, setError] = useState<any>(null);

  useEffect(() => {
    const token: any = Cookies.get("token");
    const fetchSedes = async () => {
      setLoading(true);
      const response = await getSedesCorreosCRAdmin(token);
      if (!response.ok) {
        setError('No se pudo cargar las sedes de correos cr');
        setSedes([]);
      } else {
        console.log(response.sedes.sedeCorreosCR);

        setSedes(response.sedes.sedeCorreosCR);
      }
      setLoading(false);
    };

    fetchSedes();
  }, []);

  const rows: GridRowsProp = sedes

  const [filterModel, setFilterModel] = React.useState<GridFilterModel>({
    items: [],
    quickFilterExcludeHiddenColumns: true,
    quickFilterValues: [''],
  });

  const [columnVisibilityModel, setColumnVisibilityModel] =
    React.useState<GridColumnVisibilityModel>({});
  /* las tablas end */

  /* para agregar y editar cursos start */

  // Formulario para agregar nuevos cursos
  const {
    register: registerAdd,
    handleSubmit: handleSubmitAdd,
    formState: { errors: errorsAdd },
    reset: resetAdd
  } = useForm({
    defaultValues: {
      nombre: '',
      direccion: '',
      provincia: ''
    }
  });

  // Formulario para editar cursos existentes
  const {
    register: registerEdit,
    handleSubmit: handleSubmitEdit,
    formState: { errors: errorsEdit },
    reset: resetEdit,
    setValue: setValueEdit
  } = useForm();

  const [openAddDialog, setOpenAddDialog] = useState(false);
  const [openEditDialog, setOpenEditDialog] = useState(false);
  const [editData, setEditData] = useState({});

  const handleOpenAddDialog = () => {
    setOpenAddDialog(true);
  };

  const handleCloseAddDialog = () => {
    setOpenAddDialog(false);
    resetAdd();
  };

  const handleOpenEditDialog = (row: any) => {
    setEditData(row);
    resetEdit(row);  // Pre-carga los datos existentes en el formulario para editar
    setOpenEditDialog(true);
  };

  const handleCloseEditDialog = () => {
    setOpenEditDialog(false);
  };

  const handleSaveAdd = handleSubmitAdd(async (data) => {

    setLoading(true);
    await postSedeCorreosCR(token, data);

    //resetear la tabla
    const response = await getSedesCorreosCRAdmin(token);
    if (!response.ok) {
      setError('No se pudo cargar las sedes de correos cr');
      setSedes([]);
    } else {
      setSedes(response.sedes.sedeCorreosCR);
    }
    setLoading(false);
    handleCloseAddDialog();


  });

  const handleSaveEdit = handleSubmitEdit(async (data) => {

    // Lógica para editar el curso aquí

    setLoading(true);
    await putSedeCorreosCR(token, data);

    //resetear la tabla
    const response = await getSedesCorreosCRAdmin(token);
    if (!response.ok) {
      setError('No se pudo cargar las sedes de correos cr');
      setSedes([]);
    } else {
      setSedes(response.sedes.sedeCorreosCR);
    }
    setLoading(false);


    handleCloseEditDialog();
  });

  /* para aagregar y editar datos end */


  /* para borrar datos start */
  const [openDeleteDialog, setOpenDeleteDialog] = useState(false);
  const [deleteId, setDeleteId] = useState(null);

  const handleOpenDeleteDialog = (id: any) => {
    setDeleteId(id);
    setOpenDeleteDialog(true);
  };

  const handleCloseDeleteDialog = () => {
    setOpenDeleteDialog(false);
  };

  const handleDelete = async (id: any) => {
    // Lógica para eliminar el curso


    setLoading(true);
    await deleteSedeCorreosCR(token, id);

    //resetear la tabla
    const response = await getSedesCorreosCRAdmin(token);
    if (!response.ok) {
      setError('No se pudo cargar las sedes de correos cr');
      setSedes([]);
    } else {
      setSedes(response.sedes.sedeCorreosCR);
    }
    setLoading(false);

    // Aquí añades la llamada a la API para eliminar el curso
    handleCloseDeleteDialog();
  };
  /* para borrar datos end  */

  return (
    <AdminLayout title='SedeCorreos'>

      <>

        {loading ? <LoadingScreen /> :
          error ? <div>Error: {error}</div>
            : <Paper 
              sx={{ overflow: "hidden", width: "100%", borderRadius: 2, mt: 0, p: 2 }}

            >

              <Grid item xs={12} container alignItems="center" justifyContent="space-between" mb={1}>
                <Box >
                  <Typography
                    fontSize={22} component="div" align="left" >
                    Todas las Sedes de Correos CR
                  </Typography>
                </Box>

                <Button onClick={handleOpenAddDialog} variant="contained" color="primary">Agregar nueva sede</Button>
              </Grid>


              <Box sx={{ height: '85vh' }}>
                <DataGrid
                  columns={columns}
                  rows={rows}
                  sx={{ padding: "10px" }}
                  slots={{ toolbar: GridToolbar }}
                  filterModel={filterModel}
                  onFilterModelChange={(newModel) => setFilterModel(newModel)}
                  slotProps={{
                    toolbar: {
                      showQuickFilter: true,

                    },
                  }}
                  columnVisibilityModel={columnVisibilityModel}
                  onColumnVisibilityModelChange={(newModel) =>
                    setColumnVisibilityModel(newModel)
                  }
                />
              </Box>
            </Paper>
        }
      </>




      <Grid container justifyContent="space-between" alignItems="center" mb={2}>

        {/* Dialog for Adding New sede */}
        <Dialog open={openAddDialog} onClose={handleCloseAddDialog}>
          <form onSubmit={handleSaveAdd}>
            <DialogTitle>Agregar Nueva Sede de Correos</DialogTitle>
            <DialogContent>
              <TextField
                autoFocus
                margin="dense"
                id="nombre"
                label="Nombre de la Sede"
                fullWidth
                variant="outlined"
                {...registerAdd("nombre", {
                  required: "El nombre es requerido",
                  minLength: {
                    value: 5,
                    message: "El nombre debe tener al menos 5 caracteres"
                  }
                })}
                error={Boolean(errorsAdd.nombre)}
                helperText={errorsAdd.nombre?.message}
              />
              <TextField
                autoFocus
                margin="dense"
                id="direccion"
                label="Direccion de la Sede de Correos"
                fullWidth
                variant="outlined"
                {...registerAdd("direccion", {
                  required: "La direccion es requerida",
                  minLength: {
                    value: 5,
                    message: "La direccion debe tener al menos 5 caracteres"
                  }
                })}
                error={Boolean(errorsAdd.direccion)}
                helperText={errorsAdd.direccion?.message}
              />
              <TextField
                select
                label="Provincia"
                fullWidth
                margin="dense"
                id="provincia"
                variant="outlined"
                {...registerAdd("provincia", {
                  required: "La provincia es requerida",
                  validate: value => ['San_Jose', 'Alajuela', 'Heredia', 'Cartago', 'Puntarenas', 'Guanacaste', 'Limon'].includes(value) || "Debe ser una Provincia válida"
                })}
                error={Boolean(errorsAdd.provincia)}
              >

                <MenuItem value="San_Jose">San Jose</MenuItem>
                <MenuItem value="Alajuela">Alajuela</MenuItem>
                <MenuItem value="Heredia">Heredia</MenuItem>
                <MenuItem value="Cartago">Cartago</MenuItem>
                <MenuItem value="Puntarenas">Puntarenas</MenuItem>
                <MenuItem value="Guanacaste">Guanacaste</MenuItem>
                <MenuItem value="Limon">Limon</MenuItem>
              </TextField>
            </DialogContent>
            <DialogActions>
              <Button onClick={handleCloseAddDialog} color="error">Cancelar</Button>
              <Button type="submit" color="primary">{loading ? <CircularProgress /> : "Guardar"}</Button>
            </DialogActions>
          </form>
        </Dialog>

      </Grid>

      {/* Dialog for Editing Existing Course */}
      <Dialog open={openEditDialog} onClose={handleCloseEditDialog}>
        <form onSubmit={handleSaveEdit}>
          <DialogTitle>Editar Sede de Correos CR</DialogTitle>
          <DialogContent>
            <TextField
              autoFocus
              margin="dense"
              id="nombre"
              label="Nombre de la sede"
              type="text"
              fullWidth
              {...registerEdit("nombre", {

                minLength: { value: 5, message: "El nombre debe tener al menos 5 caracteres" }
              })}
              error={Boolean(errorsEdit.nombre)}

            />

            <TextField
              autoFocus
              margin="dense"
              id="direccion"
              label="Direccion de la Sede de Correos"
              fullWidth
              variant="outlined"
              {...registerEdit("direccion", {

                minLength: {
                  value: 5,
                  message: "La direccion debe tener al menos 5 caracteres"
                }
              })}
              error={Boolean(errorsAdd.direccion)}
              helperText={errorsAdd.direccion?.message}
            />
            <TextField
              select
              label="Provincia"
              fullWidth
              margin="dense"
              id="provincia"
              variant="outlined"
              value={(editData as any).provincia || ''}  // Asegura que el valor actual se maneje con el estado
              onChange={e => {
                const newProvincia = e.target.value;
                setEditData(prev => ({ ...prev, provincia: newProvincia }));  // Actualiza el estado local
                setValueEdit('provincia', newProvincia, { shouldValidate: true });  // Actualiza el valor en el formulario
              }}
              error={Boolean(errorsEdit.provincia)}

            >
              <MenuItem value="San_Jose">San Jose</MenuItem>
              <MenuItem value="Alajuela">Alajuela</MenuItem>
              <MenuItem value="Heredia">Heredia</MenuItem>
              <MenuItem value="Cartago">Cartago</MenuItem>
              <MenuItem value="Puntarenas">Puntarenas</MenuItem>
              <MenuItem value="Guanacaste">Guanacaste</MenuItem>
              <MenuItem value="Limon">Limon</MenuItem>
            </TextField>





          </DialogContent>
          <DialogActions>
            <Button onClick={handleCloseEditDialog} color="error">Cancelar</Button>
            <Button type="submit" color="primary">{loading ? <CircularProgress /> : "Guardar"}</Button>
          </DialogActions>
        </form>
      </Dialog>



      <Dialog open={openDeleteDialog} onClose={handleCloseDeleteDialog}>
        <DialogTitle>Confirmación</DialogTitle>
        <DialogContent>
          <DialogContentText>¿Estás seguro de que quieres eliminar esta sede de correos?</DialogContentText>
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCloseDeleteDialog}>No</Button>
          <Button onClick={() => handleDelete(deleteId)} color="error" autoFocus>{loading ? <CircularProgress /> : "Sí"}</Button>
        </DialogActions>
      </Dialog>

    </AdminLayout>
  )
}
